'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _utilsBorder = require('./utils/border');

var _utilsBorder2 = _interopRequireDefault(_utilsBorder);

var ImageBox = function ImageBox(props) {
	var style = {};

	//size
	if (!!props.height) style.height = props.height;
	if (!!props.width) style.width = props.width;
	if (!!props.minWidth) style.minWidth = props.minWidth;
	if (!!props.minHeight) style.minHeight = props.minHeight;

	//border
	(0, _utilsBorder2['default'])(style, props.border);

	if (props.objectFit) style.objectFit = props.objectFit || 'fill';
	if (props.clipPath) {
		style.clipPath = props.clipPath;
		style.WebkitClipPath = props.clipPath;
	}
	if (!!props.flexGrow) style.flexGrow = props.flexGrow;

	return _react2['default'].createElement('img', { src: props.url, style: style });
};
var DEFAULT_IMAGE_URL = "data:image/gif;base64,R0lGODlhAQABAIAAAHd3dwAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==";
ImageBox.defaultProps = { url: DEFAULT_IMAGE_URL, minWidth: 100, minHeight: 100 };
exports['default'] = ImageBox;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-photo-widget-factory/lib/widgets/ImageBox.js
 ** module id = 500
 ** module chunks = 0
 **/